export default {"src":"/_next/static/media/trustpilot-logo-black.0d59a2a1.svg","height":34,"width":140,"blurWidth":0,"blurHeight":0};